import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["className", "onClose"];
import { cross_16 as cross16 } from "@trustpilot/icons";
import { useLocalization } from "../PatternLibraryProvider";
import { Icon } from "../Icon";
import * as translations from "./localization";
import { closeButtonStyles } from "./styles";
import { jsx as ___EmotionJSX } from "@emotion/core";
export var ModalCloseButton = function ModalCloseButton(_ref) {
  var className = _ref.className,
    onClose = _ref.onClose,
    rest = _objectWithoutProperties(_ref, _excluded);
  var _useLocalization = useLocalization(translations),
    strings = _useLocalization.strings;
  return ___EmotionJSX("button", _extends({
    "data-bpl": true,
    className: className,
    onClick: onClose,
    css: closeButtonStyles,
    "aria-label": strings.close,
    "data-testid": "modal-close-button"
  }, rest), ___EmotionJSX(Icon, {
    content: cross16,
    "data-testid": "modal-close-icon",
    color: "currentColor"
  }));
};